import { get, post } from '../config/$ajax.js'
import { getErpHost } from '@/utils/domainHelper.js';
import { DEFAULT_AMOUNT_DIGIT } from '@/dictionary/index.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};

/** 店铺管理 */
// 获取店铺列表
export const getShopData = (data = {}, params = {}) => {
    return get('/shop/info', data, {isNeedLoading: false, ...params});
}
/** 店铺管理 不分页 */
// 获取所有店铺列表
export const getNoPageShopData = (data = {}, params = {}) => {
    if(data.source === 'alibaba') {
        data.source = '1688'
    }
    return get('/shop/allShop', data, params);
}
// 修改店铺信息
export const eidtShopData = (data = {}) => {
    return post('/shop/info/save/sys', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}
// 同步店铺类目
export const submitCategoryTask = (data = {}) => {
    return get('/category/base/submitCategoryTask', data);
}
// 解除店铺异常接口
export const operateCacheByShop = (data = {}) => {
    return get('/shop/operateCacheByShop', data);
}
// 查看店铺类目同步进度
export const querySubmitCategoryResult = (data = {}) => {
    return post('/category/base/querySubmitCategoryResult', {
        ...data,
        taskTypeEnum: 'SYNC_PLATFORM_CATEGORY'
    }, {isNeedLoading: false})
}
// 修改视频号信息
export const eidtWxsphShopData = (data = {}) => {
    return post('/erp/proxy/shop/info/save/sys', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}
/** 负责人管理 */
// 获取负责人信息
export const getContactData = (data = {}, params = {}) => {
    return get('/companyBusinessInfo/showOfficialInfo', data, {isNeedLoading: true});
}
  
// 修改负责人信息
export function editContactData (data = {}) {
    return post('/companyBusinessInfo/editOfficialInfo', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

// 校验手机号码
export function checkIdentifyCode (data = {}, params = {}) {
    return post(`/account/checkIdentifyCode?date=${(new Date()).getTime()}`, data, params);
}

// 获取图片编辑器网站token
export function getPimToken(data={}) {
    return getAjax('index/getPimToken', data);
}

/** 用户管理 */
// 获取用户列表
export function queryStaffInfo(data={}) {
    return post('/staff/query', data);
}
// 新增, 修改用户
export function saveOrUpdateStaffInfo(data={}) {
    return post('/staff/saveOrUpdateStaffInfo', data);
}
// 获取账号
export function getAcountList(data={}) {
    return get('/account/getAccountList', data, {isNeedLoading: false});
}
// 新增创建账号
export function createNewAccount(data={}) {
    return post('/account/createNewAccount', data, { submitType: 'json', headers:{'Content-Type':'application/json'}});
}
// 修改登录密码
export function editPassword(data={}) {
    return post('/user/updatePassword4Normal', data, { submitType: 'json', headers:{'Content-Type':'application/json'}});
}
// 重置登录密码
export function resetPassword(data={}) {
    return post('/account/resetPassword', data);
}

// 新增用户时 获取用户权限
export function gylShowCreateStaff(data={}) {
    return get('/staff/gylShowCreateStaff', data);
}
// 修改用户时 获取用户权限
export function gylShowEditStaff(data={}) {
    return get('/staff/gylShowEditStaff', data);
}
// 
export function showStaffData(data={}) {
    return get('/staff/showEditStaffShop', data);
}
/**
 * 查询员工基本信息
 * @param {*} data 参数
 * @returns
 */
export function showStaffSimpleData(data={}) {
    return getAjax('staff/querySimpleInfoById', data);
}

/**
 * 一些公共接口
 */

export function getBase64(imageUrl, opt = {}) {
    return get('/image/imgBase64', {imageUrl}, opt);
}
export function getImgFileSize(imageUrl, opt = {}) {
    return get('/image/getImageSize', {imageUrl}, opt);
}
export function getPddShopAuthStatus(data) {
    return post('/pdd/authorize/authStatus', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

// 获取金额精度位数
export const queryAmountDigit = (params) => {
    return get('/api/wx/gzh/queryAmountDigits', params, {isNeedLoading: false}).then(res => {
      return res.result == 1 ? (res.data || DEFAULT_AMOUNT_DIGIT) : Promise.reject(res);
    });
};
/**
 * 
 * @param {
 * type(invite:邀请建立供分销关系; beinvite:接受供分销关系; share_store:分享小店;  share_item:分享小店	分享小店商品)
 * source(pc:电脑端； wx:小程序端)
 * companyId: companyId	当前公司id
 * companyName: companyName	当前公司名称
 * businessId: 发起分享的公司id / 分享的款编码
 * bizName: 发起分享的公司名称 / 分享的商品名称
 * loginIdentity(1:供销商； 2:分销商)
 * } data 
 * @returns 
 */
export function addStatisticsLog(data) {
    return post('/logging/addStatisticsLog', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}
// 获取erp环境
export function getEnv(data={}) {
    data.from = location.hostname;
    return get('/user/getEnv', data);
}

// 通过货源池的商品id获取基础商品详情
export function getDetailByOceanItemIds(data) {
    return post('/item/base/detailByOceanItemIds', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}
/** 展架分类接口  */

/**
 * 获取展架列表
 */
export function getBaseItemDisplay(data={}) {
    return get('/crm/display/getBaseItemDisplay', data);
}

/**
 * 修改展架名
 */
export function updateDisplayName(data) {
    return post('/crm/display/updateDisplayName', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/**
 * 删除展架
 */
export function delDisplayClassify(data) {
    return post('/crm/display/delDisplayClassify', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/**
 * 置顶展架
 */
export function topDisplayClassify(data) {
    return post('/crm/display/topDisplayClassify', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/**
 * 新增分类
 */
export function addBaseItemDisplay(data) {
    return post('/crm/display/addBaseItemDisplay', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/**
 * 新增分类
 */
export function moveDisplayClassify(data) {
    return post('/crm/display/moveDisplayClassify', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/**
 * 添加商品展架
 */
export function addItemDisplayCode(data) {
    return post('/distribution/shop/item/itemDisplayCode', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}

/** end  */

// 获取供分销合作关系
export function fetchCheckUnfinishedOrders(data = {}) {
    return getAjax('/dms/checkUnfinishedOrders', data);
}
/**
 * 获取是否是星云客户，展示找好货和找供应商菜单
 * @param {*} companyId  当前公司id
 * @returns data 是否有值，有值就是星云客户，无值就是非星云客户
 */
export function oceanShopQueryUserInXy(data) {
    return get('/api/ocean/shop/queryUserInXy.json', data);
}

// 记录从 SCM 进入货源池页面的流量
export function recordOceanTraffic(pageCode) {
    return postAjax('/dms/ocean/traffic/record', {
        sourceSystem: 'SCM',
        pageCode,
    }, {
        appJson: true,
        submitType: 'json',
        isNeedLoading: false,
        isSilentRequest: true,
    });
}


// 获取公众号余额预警二维码地址
export function generateBalanceWarnQRCode(params = {}) {
    return getAjax('/dms/generateBalanceWarnQRCode', params, { isNeedLoading: false, noTips: true });
}

export function listFxgShopsGrayStatus(data) {
    return get('/fxg/listFxgShopsGrayStatus', data);
}
export function setShopCache(data) {
    return get('/fxg/setShopCache', data);
}
// 根据视频id查询视频信息
export function getVideoInfo(data = {}) {
    return post('/common/video/info/list', data, {submitType: 'json', headers:{'Content-Type':'application/json'}});
}
